import { render, staticRenderFns } from "./EspeciesTabTaxonomia.vue?vue&type=template&id=685a038f&"
import script from "./EspeciesTabTaxonomia.vue?vue&type=script&lang=js&"
export * from "./EspeciesTabTaxonomia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports